import { Stmtrs } from "./Stmtrs";

export class Stmtrslist{
    constructor(){}

    Stmtrs: Stmtrs = null;

    Deserialize(input:any){
        // if (input.stmtrslist.stmtrs!=null){
        //     this.Stmtrs=[];
        //     this.Stmtrs.push(new Stmtrs().Deserialize(input.stmtrslist.stmtrs));
            
        // }
        this.Stmtrs = new Stmtrs().Deserialize(input.stmtrslist.stmtrs)
        return this;
    }



}